import { render, staticRenderFns } from "./QRcode.vue?vue&type=template&id=9b7e77e2&scoped=true&"
import script from "./QRcode.vue?vue&type=script&lang=js&"
export * from "./QRcode.vue?vue&type=script&lang=js&"
import style0 from "./QRcode.vue?vue&type=style&index=0&id=9b7e77e2&lang=less&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "9b7e77e2",
  null
  
)

export default component.exports